/**
 *
 * EventRedirect
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';

import Spinner from '@/components/Spinner.vue';

import { LOADING_MESSAGE } from './PlvLiveRedirect.constants';

export default {
  name: 'PlvLiveRedirect',

  components: {
    Spinner,
  },

  data() {
    return {
      loadingMessage: LOADING_MESSAGE,

      redirect_uri: '',
    };
  },

  computed: {
    ...mapState('PlvLiveRedirect', {
      ms_plvWatchLink: 'plvWatchLink',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),
  },

  methods: {
    ...mapActions('PlvLiveRedirect', {
      ma_getPlvWatchLink: 'getPlvWatchLink',
    }),

    async getPlvWatchLink() {
      await this.ma_getPlvWatchLink({
        channelId: this.$route.params.channelId,
      });
      if (this.ms_plvWatchLink) {
        window.location.href = this.ms_plvWatchLink;
      }
    },
  },

  created() {
    this.getPlvWatchLink();
  },
};
